// extracted by mini-css-extract-plugin
module.exports = {"root":"Messages_root__2uSpz","header":"Messages_header__3yoXa"};